import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative flex flex-col items-center justify-center px-4 sm:px-6 overflow-hidden pt-32 sm:pt-40 md:pt-48 pb-20 sm:pb-32 md:pb-40" data-id="element-62">
      {/* Subtle animated radial gradient glow */}
      <motion.div className="absolute inset-0 z-0 flex items-center justify-center opacity-20 pointer-events-none" animate={{
      scale: [1, 1.05, 1],
      opacity: [0.05, 0.15, 0.05]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-63">
        <div className="w-[400px] h-[400px] sm:w-[600px] sm:h-[600px] md:w-[800px] md:h-[800px] rounded-full bg-brand-gold blur-[100px] md:blur-[150px]" data-id="element-64" />
      </motion.div>

      <div className="z-10 flex flex-col items-center text-center w-full max-w-4xl" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.0,
        ease: 'easeOut'
      }} className="-mb-12 sm:-mb-20 md:-mb-28 -mt-8 sm:-mt-12 md:-mt-16 flex justify-center w-full" data-id="element-66">
          <img src="https://cdn.magicpatterns.com/uploads/4QnKWqMyoVtYRAEErqpPgC/ChatGPT_Image_Apr_30,_2026,_04_00_28_PM.png" alt="Pollock Ventures" className="w-[340px] sm:w-[600px] md:w-[820px] lg:w-[960px] h-auto select-none" data-id="element-67" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-68">
          <p className="font-heading text-2xl sm:text-3xl md:text-5xl text-brand-offWhite mb-12 sm:mb-16 font-extralight tracking-tight" data-id="element-69">
            Investing in what's next.
          </p>

          {/* Vertical line visual cue */}
          <motion.div className="w-px h-20 sm:h-32 bg-gradient-to-b from-brand-gold/60 to-transparent" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} transition={{
          duration: 1.0,
          delay: 1.4,
          ease: 'easeInOut'
        }} data-id="element-70" />
        </motion.div>
      </div>
    </section>;
}